module.exports = __WEBPACK_EXTERNAL_MODULE__822__;